import { getIsAllowed, getIsUpdated } from './utils';
import { Box, Button, Flex, Heading, useStyleConfig } from '@chakra-ui/react';

const MenuItem = ({ props, formikProps, sectionTitle, sectionName, menu }) => {
  const stateProps = props.stateProps;
  const resumes = stateProps.dataToSave.saved.resumes;
  const resumeIndex = stateProps.sectionData.resumeIndex
  const variant = 'wrapper';
  const buttonStyles = useStyleConfig('Button', { variant });
  let checkAI = false;
  let update = 'Update';
  if(sectionName === 'career-profile' ) {
    checkAI = true;
  }
  let newSectionIndex = 0;
  const section = resumes[resumeIndex][sectionName]
  if( section === undefined || section === null) {
    newSectionIndex = 0;
  } else {
    newSectionIndex = resumes[resumeIndex][sectionName].length-1;
  }
  if (!getIsAllowed(props.navSections[menu].sections, sectionName)) {
    return null;
  } else {
    const updated = getIsUpdated(props, sectionName);
    return (
      <Flex
        flexDirection='row'
        justifyContent='space-between'
        alignItems='center'
        width='100%'
      >
        <Heading variant='b18' width='100%'>
          {sectionTitle}
        </Heading>
        <Box>
          {updated ? (
            <Button
              sx={{...buttonStyles.update}}
                    onClick={() => props.handlers.onLink(false, formikProps, stateProps, sectionName, 0, 'section', '', props)}>
              {update}
            </Button>
          ) : (
            <Button
              sx={{...buttonStyles.tertiary,...buttonStyles.start}}
                    onClick={() => props.handlers.onLink(checkAI,formikProps, stateProps, sectionName,0,'section','',props)}>
              Start
            </Button>
          )}
        </Box>
      </Flex>
    );


  }
};

export default MenuItem;